import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tinycolor from "tinycolor2";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { mapActions, mapState } from "vuex";
import { LOAD_APPLICATION_AUTOMATIONS } from "@Broker/@Modules/automation/automation/store/automation-actions";
import { UPDATE_MUTED_AUTOMATIONS } from "../../store/application-actions";
import ManageAutomationsLoader from "./manage-automations-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ManageAutomationsModal",
  components: {
    GenericModal,
    ManageAutomationsLoader
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AutomationStore", {
    applicationAutomationTriggers(state) {
      return _Object$values(state.appAutomationData.entities.trigger);
    }
  })), mapState("ApplicationStore", {
    mutedAutomations(state) {
      return state.mutedAutomations.byApplication[this.applicationId];
    }
  })), {}, {
    automationTypes() {
      var _context;
      return _mapInstanceProperty(_context = this.applicationAutomationTriggers).call(_context, trigger => {
        var _context2;
        return {
          key: trigger.key,
          label: trigger.name,
          style: trigger.style,
          description: trigger.description,
          muted: _includesInstanceProperty(_context2 = this.mutedAutomations).call(_context2, trigger.key)
        };
      });
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AutomationStore", [LOAD_APPLICATION_AUTOMATIONS])), mapActions("ApplicationStore", [UPDATE_MUTED_AUTOMATIONS])), {}, {
    getHeaderStyle(style) {
      const bgColor = tinycolor(style["background-color"]);
      return {
        "border-left-color": `${bgColor.darken(bgColor.isDark() ? 0 : 100)} !important`,
        "background-color": `${bgColor.lighten(bgColor.isLight() ? 0 : 40)} !important`
      };
    },
    getTitleColor(style) {
      const bgColor = tinycolor(style["background-color"]);
      const colorToUse = `${bgColor.lighten(bgColor.isLight() ? 50 : 0)} !important`;
      return {
        color: colorToUse
      };
    },
    getDescriptionColor(style) {
      const bgColor = tinycolor(style["background-color"]);
      let colorToUse = `#9e9e9e !important`;
      if (bgColor._originalInput === "#5f5b6b") colorToUse = "#fafafa";
      return {
        color: colorToUse
      };
    },
    async toggleAutomationMute(automationKey, automationMuted) {
      var _context3;
      const mutedAutomations = automationMuted ? _filterInstanceProperty(_context3 = this.mutedAutomations).call(_context3, automation => automation !== automationKey) : [...this.mutedAutomations, automationKey];
      await this.UPDATE_MUTED_AUTOMATIONS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        mutedAutomations
      });
    },
    async handleShow() {
      this.loading = true;
      await this.LOAD_APPLICATION_AUTOMATIONS();
      this.loading = false;
    }
  })
});